import React from 'react';
import { FilterSelective, FilterDateTimeRange } from 'components';
import jMoment from 'moment-jalaali';

const actions = [
  {
    label: 'ورود',
    value: 'LOGIN',
  },
  {
    label: 'خروج',
    value: 'LOGOUT',
  },
  {
    label: 'بروز رسانی پروفایل',
    value: 'UPDATEPROFILE',
  },
  {
    label: 'ثبت نام',
    value: 'SIGNUP',
  },
  {
    label: 'تغییر رمز',
    value: 'CHANGEPASS',
  },

  {
    label: 'بروزرسانی موردی',
    value: 'UPDATETHING',
  },
  {
    label: 'نوتیفیکیشن',
    value: 'NOTIFICATION',
  },
  {
    label: 'همه',
    value: null,
  },
];

const getActionText = (val) => {
  const r = actions?.find((v) => v?.value?.toLocaleLowerCase() == val?.toLocaleLowerCase());
  if (!r) return '-';
  return r?.label;
};

const commonStatus = [
  {
    label: 'موفق',
    value: 'OK',
  },
  {
    label: 'ناموفق',
    value: 'FAILED',
  },
  {
    label: 'همه',
    value: null,
  },
];

const columns = [

  {
    title: 'فعالیت',
    field: 'action', // 1384
    align: 'center',
    render: (rowData) => getActionText(rowData?.action),
    filterComponent: (props) => <FilterSelective options={actions} size="small" {...props} />,
  },
  {
    title: 'وضعیت',
    field: 'status', // 1384
    align: 'center',
    filterComponent: (props) => <FilterSelective options={commonStatus} size="small" {...props} />,
    render: (rowData) =>
      rowData?.status ? (rowData?.status.toLowerCase() != 'ok' ? 'ناموفق' : 'موفق') : '-',
  },
  {
    title: 'زمان',
    field: 'time',
    align: 'center',
    render: (rowData) => jMoment(rowData?.time).format('dddd, jD jMMMM jYYYY - HH:mm'),
    filterComponent: (props) => <FilterDateTimeRange size="small" variant="outlined" {...props} />,
  },
  {
    title: 'IP',
    field: 'invoiceId', // 1349
    align: 'center',
    render: (rowData) => rowData?.device?.ip ?? '-',
    filtering: false,
    cellStyle: {
      fontFamily: 'Vazir',
    },
  },
  {
    title: 'دستگاه',
    field: 'invoiceId', // 1349
    filtering: false,
    align: 'center',
    render: (rowData) => rowData?.device?.deviceType ?? '-',
  },
  {
    title: 'سیستم عامل',
    field: 'invoiceId', // 1349
    filtering: false,
    align: 'center',
    render: (rowData) => rowData?.device?.os ?? '-',
    cellStyle: {
      fontFamily: 'Vazir',
    },
  },
  {
    title: 'مرورگر',
    field: 'browser', // 1349
    align: 'center',
    filtering: false,
    render: (rowData) => rowData?.device?.browser ?? '-',
    cellStyle: {
      fontFamily: 'Vazir',
    },
  },
  {
    title: 'پذیرنده',
    field: 'name', // 1349
    align: 'center',
    filtering: false,
    render: (rowData) => rowData?.client?.name ?? '-',
  },
];

const columnsId = {
  invoiceId: '1349',
  tax: '1444',
  invoiceStatus: '1352',
  guildName: '1353',
  decreased: '1354',
  hasMultiInvoice: '1384',
};

export { columns, columnsId };
